<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['react']);

const reactionList = computed(() => {
  return Object.entries(props.reactions)
    .filter(([, count]) => count > 0)
    .map(([emoji, count]) => ({ emoji, count }));
});

function handleClick(emoji) {
  emit('react', emoji);
}
</script>

<template>
  <!-- A reação que chega faz um pop curto e a que sai esmaece (24/10/2026); as vizinhas
       deslizam para o lugar em vez de pular. -->
  <!-- eslint-disable-next-line vue/no-root-v-if -->
  <TransitionGroup
    v-if="reactionList.length > 0"
    tag="div"
    name="msg-reacao"
    class="flex flex-wrap gap-1 mt-1"
  >
    <button
      v-for="{ emoji, count } in reactionList"
      :key="emoji"
      class="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-xs bg-n-alpha-2 hover:bg-n-alpha-3 border border-n-weak cursor-pointer transition-colors"
      @click="handleClick(emoji)"
    >
      <span>{{ emoji }}</span>
      <span v-if="count > 1" class="text-n-slate-11">{{ count }}</span>
    </button>
  </TransitionGroup>
</template>

<style scoped>
.msg-reacao-enter-active {
  transition:
    opacity var(--mov-2) var(--mov-curva),
    transform var(--mov-3) var(--mov-curva);
}

.msg-reacao-leave-active {
  position: absolute;
  transition: opacity var(--mov-1) var(--mov-curva-saida);
}

.msg-reacao-move {
  transition: transform var(--mov-2) var(--mov-curva);
}

.msg-reacao-enter-from {
  opacity: 0;
  transform: scale(0.6);
}

.msg-reacao-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .msg-reacao-enter-from {
    transform: none;
  }
}
</style>
